"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ImageWidget_1 = tslib_1.__importStar(require("../widget/ImageWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
class SnackBar {
    static show(options) {
        const { headerText, bodyText, showCloseButton = true, delay = 6000, cssClasses, snackbarSeverity = fmko_ts_common_1.SnackbarSeverity.INFO, listener, persist = false } = options ?? {};
        const mainDiv = document.createElement("div");
        if (cssClasses) {
            mainDiv.classList.add(...cssClasses);
        }
        mainDiv.classList.add("snack-bar", snackbarSeverity);
        const leftSide = document.createElement("div");
        leftSide.classList.add("snack-bar-left-side");
        const rightSide = document.createElement("div");
        rightSide.classList.add("snack-bar-right-side");
        mainDiv.appendChild(leftSide);
        mainDiv.appendChild(rightSide);
        const chatImage = new ImageWidget_1.default({
            alt: "Ny besked",
            imageDimension: ImageWidget_1.ImageDimensions.L,
            src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.SUPPORT)
        });
        chatImage.addCssClass("snack-bar-image");
        leftSide.appendChild(chatImage.element);
        const headerSpan = document.createElement("h3");
        headerSpan.textContent = headerText;
        leftSide.appendChild(headerSpan);
        if (bodyText) {
            const bodySpan = document.createElement("span");
            bodySpan.classList.add("snack-bar-span");
            bodySpan.textContent = bodyText;
            leftSide.appendChild(bodySpan);
        }
        const removeEvent = event => {
            if (event.target === mainDiv
                || event.target.parentElement === mainDiv
                || event.target.parentElement.parentElement === mainDiv) {
                SnackBar.removeSnackBar(mainDiv, event);
            }
        };
        let actionElement;
        if (showCloseButton && !listener) {
            actionElement = SnackBar.getActionElement({
                event: () => {
                    SnackBar.removeSnackBar(mainDiv);
                }
            }, snackbarSeverity);
            rightSide.appendChild(actionElement);
        }
        else if (listener) {
            actionElement = SnackBar.getActionElement(listener, snackbarSeverity);
            rightSide.appendChild(actionElement);
        }
        document.body.appendChild(mainDiv);
        if (!showCloseButton) {
            document.body.addEventListener("click", removeEvent, true);
        }
        // Ensures the element has been loaded
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        window.getComputedStyle(mainDiv).opacity; // tslint:disable-line
        mainDiv.classList.add("visible");
        if (!persist) {
            window.setTimeout(() => {
                SnackBar.removeSnackBar(mainDiv, removeEvent);
            }, delay);
        }
    }
    static removeSnackBar(mainDiv, listener) {
        if (mainDiv) {
            mainDiv.classList.remove("visible");
            window.setTimeout(() => {
                if (mainDiv.parentElement === document.body) {
                    document.body.removeChild(mainDiv);
                    if (listener) {
                        document.body.removeEventListener("click", listener, true);
                    }
                }
            }, 500);
        }
    }
    static getActionElement({ text, event }, snackbarSeverity) {
        if (text) {
            const snackBarActionButton = document.createElement("button");
            snackBarActionButton.classList.add("snackbar-action");
            snackBarActionButton.innerText = text;
            snackBarActionButton.addEventListener("click", event);
            return snackBarActionButton;
        }
        else {
            const closeButton = new ImageWidget_1.default({
                alt: "Luk",
                imageDimension: ImageWidget_1.ImageDimensions.L,
                src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.CLOSE)
            });
            closeButton.addCssClass("snack-bar-image");
            let backgroundColor;
            switch (snackbarSeverity) {
                case fmko_ts_common_1.SnackbarSeverity.INFO:
                    backgroundColor = fmko_ts_common_1.ButtonBackgroundColor.DARK_GREY;
                    break;
                case fmko_ts_common_1.SnackbarSeverity.WARNING:
                    backgroundColor = fmko_ts_common_1.ButtonBackgroundColor.WARNING;
                    break;
                case fmko_ts_common_1.SnackbarSeverity.ERROR:
                    backgroundColor = fmko_ts_common_1.ButtonBackgroundColor.ERROR;
                    break;
            }
            fmko_ts_common_1.WCAG.addButtonEvent({
                buttonBackgroundColor: backgroundColor,
                callback: event,
                element: closeButton.element
            });
            return closeButton.element;
        }
    }
}
exports.default = SnackBar;
//# sourceMappingURL=SnackBar.js.map